// extracted by mini-css-extract-plugin
export default {"player":"player__dS0h8","whiteBg":"whiteBg__qJj8R"};